import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=7a55f6dc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a55f6dc')) {
      api.createRecord('7a55f6dc', component.options)
    } else {
      api.reload('7a55f6dc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=7a55f6dc&", function () {
      api.rerender('7a55f6dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4yzlc7JZuBXQ4/JS/pricehelp.vue"
export default component.exports